<kpa-loader></kpa-loader>

<div class="sort-filter">
	<div class="sort-label-dropdown">
		<label for="sortBy">Sort by: </label>
		<kendo-dropdownlist
			id="sort-drp"
			class="opentasks-sort"
			[data]="sortOptions"
			[textField]="'text'"
			[valueField]="'value'"
			[(ngModel)]="selectedSortOption"
			(valueChange)="sortTasks()">
		</kendo-dropdownlist>
	</div>
</div>
<div class="open-tasks-container">
	<kendo-stacklayout
		id="k-stack"
		*ngIf="viewOpenTasks"
		[gap]="15"
		[orientation]="'vertical'">
		<ng-container *ngIf="pagedTasks && pagedTasks.length; else noTasks">
			<kendo-card
				id="card_{{ i }}"
				[ngClass]="task.type === 'OfflineTraining' && !task.hasDocument ? 'kpa-open-tasks-card-disabled' : 'kpa-open-tasks-card'"
				*ngFor="let task of pagedTasks; let i = index"
				width="auto"
				(click)="openTask(task)">
				<kendo-card-body>
					<div class="card-content">
						<div class="card-item">
							<p>
								<span class="outer-circle">
									<kendo-svg-icon
										*ngIf="task.type === 'OfflineTraining'"
										[icon]="offlineTrainingIcon"
										class="kpa-icon"></kendo-svg-icon>
									<kendo-svg-icon
										*ngIf="task.type === 'Video'"
										[icon]="circlePlayIcon"
										class="kpa-icon"></kendo-svg-icon>
									<kendo-svg-icon
										*ngIf="task.type === 'Document' && task.contentType != 3"
										[icon]="documentIcon"
										class="kpa-icon"></kendo-svg-icon>
									<kendo-svg-icon
										*ngIf="task.type === 'OnlineTraining'"
										[icon]="trainingIcon"
										class="kpa-icon"></kendo-svg-icon>
									<kendo-svg-icon
										*ngIf="task.type === 'Audit'"
										[icon]="auditIcon"
										class="kpa-icon"></kendo-svg-icon>
									<kendo-svg-icon
										*ngIf="task.type === 'Document' && task.contentType == 3"
										[icon]="documentIcon"
										class="kpa-icon"></kendo-svg-icon>
								</span>
								<span [ngClass]="task.type === 'OfflineTraining' && !task.hasDocument ? 'title-disabled' : 'title'">
									{{ task.title }}
								</span>
							</p>
						</div>
						<div
							class="card-item"
							*ngIf="!isMobile">
							<p>{{ getContentType(task.type, task.contentType) }}</p>
						</div>
						<div
							class="card-item"
							*ngIf="task.due | dueDate">
							<p class="error">
								<kendo-svg-icon
									[icon]="warningIcon"
									size="large"></kendo-svg-icon>
								{{ task.due | date: 'MM/dd/yy' }}
							</p>
						</div>
						<div
							class="card-item"
							*ngIf="!(task.due | dueDate)">
							<p>{{ task.due | date: 'M/d/yy' }}</p>
						</div>
					</div>
				</kendo-card-body>
			</kendo-card>
		</ng-container>
		<ng-template #noTasks>
			<p>{{ noTaskScheduledMessage }}</p>
		</ng-template>
	</kendo-stacklayout>
</div>
<kendo-datapager
	style="width: 100%"
	class="kpa-open-task-pager"
	[pageSize]="pageSize"
	[skip]="skip"
	[total]="total"
	[pageSizeValues]="true"
	[info]="true"
	[previousNext]="true"
	(pageChange)="onPageChange($event)">
</kendo-datapager>
<kpa-document
	[dialogOpened]="isDocumentType"
	[documentTitle]="title"
	[documentId]="docId"
	(dialogOpenedChange)="handleDocumentAction()"
	(closeDialog)="closeDialog()"
	(onTaskComplete)="taskCompleted($event)">
</kpa-document>
<kpa-link
	[dialogOpened]="isLinkType"
	[documentTitle]="title"
	[documentId]="docId"
	[linkUrl]="linkUrl"
	(dialogOpenedChange)="handleDocumentAction()"
	(closeDialog)="closeDialog()"
	(onTaskComplete)="taskCompleted($event)">
</kpa-link>
<kpa-offlinetraining
	[dialogOpened]="isOfflineTrainingType"
	[offlineAttachments]="offlineAttachments"
	(dialogOpenedChange)="handleDocumentAction()"
	(closeDialog)="closeDialog()"
	(onTaskComplete)="taskCompleted($event)">
</kpa-offlinetraining>

<kpa-safetyvideo
	[dialogOpened]="isSafetyVideo"
	[contentURL]="contentURL"
	[isMarcom]="isMarcom"
	[scheduledId]="scheduledId"
	(closeDialog)="closeDialog()"
	(onTaskComplete)="taskCompleted($event)"></kpa-safetyvideo>

<kpa-perform-audit
	[showAudit]="isAudit"
	[currentAuditId]="currentAuditId"
	[isFromPlatform]="false"
	(onClose)="closeDialog()"
	(onTaskComplete)="taskCompleted($event)">
</kpa-perform-audit>
